<template>
  <div ref="container">
    <a-modal
      title="公司信息"
      width="70%"
      height="70%"
      :visible="visible"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'204px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭"
      style="top:8%;padding-bottom: 200px">

      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button v-if="isShowBtn" type="primary" @click="syncData">一键注册</a-button>
        <a-button v-if="isDetail" type="primary" @click="edit">编辑</a-button>
        <a-button v-else type="primary" @click="save">保存</a-button>
      </template>

      <div v-show="isDetail">
        <h3 class="h3">基本信息</h3 >
        <a-row class="r">
          <a-col :span="12" class="c">
            <div class="title">公司名称:</div>
            <div class="value">{{companyInfo.companyName}}</div>
          </a-col>
          <a-col :span="12" class="c">
            <div class="title">法定代表人:</div>
            <div class="value">{{companyInfo.legalRepresentative}}</div>
          </a-col>
          <a-col :span="12" class="c">
            <div class="title">公司地址:</div>
            <div class="value">{{companyInfo.companyMerName}},{{companyInfo.companyAddress}}</div>
          </a-col>

          <a-col :span="12" class="c">
            <div class="title">公司电话:</div>
            <div class="value">{{companyInfo.companyFax}}</div>
          </a-col>
          <a-col :span="12" class="c">
            <div class="title">统一社会信用代码:</div>
            <div class="value">{{companyInfo.socialCode}}</div>
          </a-col>
          <a-col :span="12" class="c">
            <div class="title">注册证书编号:</div>
            <div class="value">{{companyInfo.licenseCode}}</div>
          </a-col>
          <a-col :span="12" class="c">
            <div class="title">企业ID:</div>
            <div class="value">{{number()}}
              <a-icon style="margin-left: 10px" type="copy" @click="copyId"/></div>
          </a-col>

          <a-col :span="12" class="c">
            <div class="title">联系人:</div>
            <div class="value">{{companyInfo.companyContacts}}</div>
          </a-col>
          <a-col :span="12" class="c">
            <div class="title">联系电话:</div>
            <div class="value">{{companyInfo.companyTel}}</div>
          </a-col>
          <a-col :span="12" class="c">
            <div class="title">联系地址:</div>
            <div class="value">{{companyInfo.contactsMerName}},{{companyInfo.contactsAddressDetail}}</div>
          </a-col>
        </a-row>

        <hr style="border: 1px solid #dddddd">

        <!-- <h3 class="h3">单位标识</h3>

        <a-row class="r">
          <a-col :span="12" class="c">
            <div class="title">GS1:</div>
            <div class="value" v-if="companyInfo.nodeType.find(x=>x=='2')">{{companyInfo.gs1RootNode}}</div>
            <div class="value" v-else>无</div>
          </a-col>
          <a-col :span="12" class="c">
            <div class="title">MA:</div>
            <div class="value" v-if="companyInfo.nodeType.find(x=>x=='1')">{{companyInfo.rootNode}}</div>
            <div class="value" v-else>无</div>
          </a-col>

        </a-row>

        <hr style="border: 1px solid #dddddd"> -->

        <h3 class="h3">企业证照</h3>

        <a-row class="company-imglist">
          <a-col :span="8" v-for="(item,index) in imageInfo" :key="index" >
            <img :src="'/jshERP-boot/systemConfig/static/'+item.registerImage" style="width: auto;height: 240px"/>
            <div>添加时间:{{ item.createTime.substring(0, 10) }}</div>
            <div>注册人/备案名称:{{item.registerName}}</div>
            <div>注册/备案编号:{{item.registerNo}}</div>
          </a-col>

          <a-col :span="8" v-for="(item,index) in companyInfo.attachment?companyInfo.attachment.split(','):''" :key="index" >
            <img :src="'/jshERP-boot/systemConfig/static/'+item" style="width: auto;height: 310px"/>
          </a-col>

        </a-row>
      </div>
      <div v-show="!isDetail">

        <a-form-model ref="form" :model="form" :rules="rules">
          <a-row class="form-row">
            <a-col :span="24">
              <h3 class="h3">基本信息</h3>
            </a-col>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="公司名称" prop="companyName">
                <a-input placeholder="请输入公司名称" v-model="form.companyName" />
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="法定代表人" prop="legalRepresentative">
                <a-input placeholder="请输入法定代表人" v-model="form.legalRepresentative" />
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="公司地址" prop="companyAddress">
                <shengshixian ref="shengshixian1" key="1" v-model="form.companyAddressRegionCode"></shengshixian>
                <a-input placeholder="请输入地址" v-model="form.companyAddress" />
              </a-form-model-item>
            </a-col>

          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="公司电话" prop="companyFax">
                <a-input placeholder="请输入地址" v-model="form.companyFax" />
              </a-form-model-item>
            </a-col>

            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="统一社会信用代码" prop="socialCode">
                <a-input placeholder="请输入统一社会信用代码" v-model="form.socialCode" />
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" prop="companyContacts">
                <a-input placeholder="请输入联系人" v-model="form.companyContacts" />
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册证书编号" prop="licenseCode">
                <a-input placeholder="请输入注册证书编号" v-model="form.licenseCode" />
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" prop="companyTel">
                <a-input placeholder="请输入联系电话" v-model="form.companyTel" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系地址" prop="contactsAddressDetail">
                <shengshixian ref="shengshixian2" key="3" v-model="form.contactsAddressRegionCode"></shengshixian>
                <a-input placeholder="请输入联系地址" v-model="form.contactsAddressDetail" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                <j-image-upload v-model="form.attachment" bizPath="material" text="上传" isMultiple></j-image-upload>
              </a-form-model-item>
            </a-col>

            <!-- <a-col :span="24">
              <hr style="border: 1px solid #dddddd">
              <h3 class="h3">单位标识</h3>
            </a-col>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业标识码码制" prop="salesOutboundOrder">
                <a-checkbox-group v-model="form.nodeType" @change="mzChange">
                  <a-checkbox value="1">MA码(IDcode)</a-checkbox>
                  <a-checkbox value="2">GS1</a-checkbox>
                 <a-checkbox value="3">AHM</a-checkbox>
                </a-checkbox-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="MA码(IDcode)" prop="rootNode">
                <a-input v-if="form.nodeType.find(f=>f=='1')" placeholder="" v-model="form.rootNode" />
                <span v-else >无</span>
              </a-form-model-item>
            </a-col>

            <a-col :span="11">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="GS1" prop="gs1RootNode">
                <a-input v-if="form.nodeType.find(f=>f=='2')" placeholder="" v-model="form.gs1RootNode" />
                <span v-else >无</span>
              </a-form-model-item>
            </a-col> -->

<!--            <a-col :span="11">-->
<!--              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="AHM" prop="ahmRootNode">-->
<!--                <a-input v-if="form.nodeType.find(f=>f=='3')" placeholder="" v-model="form.ahmRootNode" />-->
<!--                <span v-else >无</span>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->

          </a-row>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import {mixinDevice} from '@/utils/mixin'
  import shengshixian from '@/components/shengshixian'
  import {
    addressget, addressgetByRegionCode,
    getCurrentInfo,
    systemConfigupdate,
    unitlistCertificate
  } from '@api/api'
  import JImageUpload from '@comp/jeecg/JImageUpload.vue'
  export default {
    name: "UserPassword",
    components:{
      JImageUpload,
      shengshixian
    },
    mixins: [mixinDevice],
    data () {
      return {
        isDetail:true,
        visible:false,
        isShowBtn:false,
        companyInfo:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        form:{
          nodeType:[]
        },
        rules: {
          companyName: [{ required: true, message: '请输入公司名称' }],
          legalRepresentative: [{ required: true, message: '请输入法定代表人' }],
          // companyAddress: [{ required: true, message: '请输入公司地址' }],
          companyFax: [{ required: true, message: '请输入公司电话' }],
          socialCode: [{ required: true, message: '请输入统一社会信用代码' }],
          licenseCode: [{ required: true, message: '请输入注册证书编号' }],
          companyContacts: [{ required: true, message: '请输入联系人' }],
          companyTel: [{ required: true, message: '请输入联系电话' }],
          // contactsAddressDetail: [{ required: true, message: '请输入联系地址' }],
          // gs1RootNode: [{ required: true, message: '请输入GS1码' }],
          // rootNode: [{ required: true, message: '请输入MA码' }],
        },
        imageInfo:[]
      }
    },
    methods: {
      number(){
        return localStorage.number
      },
      copyId(){
        let text = localStorage.number

        // 创建一个临时的 <textarea> 元素
        const textarea = document.createElement("textarea");
        textarea.value = text; // 设置要复制的文本
        document.body.appendChild(textarea); // 添加到文档中
        textarea.select(); // 选中文本
        try {
          document.execCommand("copy"); // 执行复制命令
          console.log("Text copied to clipboard successfully!");
          this.$message.success("复制成功")
        } catch (err) {
          console.error("Failed to copy text: ", err);
        }
        document.body.removeChild(textarea); // 移除临时元素
      },
      mzChange(){
        if(!this.form.nodeType.find(f=>f=='1')){
          this.form.rootNode = ''
        }
        if(!this.form.nodeType.find(f=>f=='2')){
          this.form.gs1RootNode = ''
        }
      },
      handleOk(){

      },
      // 一键注册
      syncData(){
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            const res = await systemConfigupdate(this.form)
            console.log(res, 'res')
            if (res.code == 200 || res.success == true) {
              this.$message.success(res.data.message)
              this.visible = false
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      },
      // 保存
      save(){
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            // 在提交前修改isCcRegist值
            const postData = {
              ...this.form,
              isCcRegist: false // 强制设置为false
            }
            const res = await systemConfigupdate(postData)
            console.log(res, 'res')
            if (res.code == 200 || res.success == true) {
              this.$message.success(res.data.message)
              this.visible = false
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      },
      edit(){
        this.$set(this,'form',this.companyInfo)
        console.log(this.companyInfo,'this.companyInfo=========')
        this.isShowBtn = this.companyInfo.isCcRegist
        this.isDetail = false
      },
      handleCancel(){
        this.visible = false
      },
      show(){
        const that = this


        unitlistCertificate({
          limit:100,
          page:1
        }).then(res=>{
          this.imageInfo = res.data.list
        })

        getCurrentInfo().then(res=>{
          console.log('===>',res)
          if( res.code == 200){
            this.companyInfo = res.data
            
            this.$set(this,'form',this.companyInfo)
            this.$nextTick(()=>{
              that.visible = true
              that.isDetail = true
            })
          } else {
            this.$message.error(res.message)
          }
          
        })
      },
    }
  }
</script>

<style >

.c{
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 14px;
}

.title{
  display: inline-block;
  padding-right: 10px;
  //padding-left: 30px ;
  font-weight: 700;
  //width: 200px;
  text-align: right;
}
.value{
  display: inline-block;
  padding-right: 10px;
}

.company-imglist .ant-col{
  text-align: center;
  margin-bottom: 20px;
}

.ant-descriptions-bordered .ant-descriptions-item-label {
  width: 176px;
}
.ant-descriptions-item-content{
  width: 200px;
}
.h3{
  display: block;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>

